<template>
    <section>
        <h4 class="text-muted mb-4">Estabelecimentos Vinculados</h4>

        <div class="heading-grid mb-2">
            <div></div>
            <h5 class="text-center">Anunciante</h5>
            <h5 class="text-center">Estabelecimento</h5>
        </div>

        <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :must-sort="true"
            :rows-per-page-items="[5]"
            no-data-text="Sem dados"
            no-results-text="Sem dados"
            sort-icon="mdi-chevron-down"
            class="wrap-header-white-space"
        >
            <v-progress-linear
                slot="progress"
                :color="providerColor"
                indeterminate
            />

            <template slot="items" slot-scope="props">
                <app-bindings-table-item
                    :data-advertiser-id="dataId"
                    :data-item="props.item"
                    :key="props.item.id"
                    @unbound="load"
                ></app-bindings-table-item>
            </template>
        </v-data-table>

        <app-establishment-bind-option-modal
            data-activator-text="Cadastrar Aparelho"
            data-entity="devices"
        ></app-establishment-bind-option-modal>
    </section>
</template>

<script>
import AppBindingsTableItem from "./components/BindingTableItem";
import EventBus from "@packages/event-bus";
import AppEstablishmentBindOptionModal from "./components/EstablishmentBindOptionModal";
import provider from "@mixins/provider";

export default {
    components: {
        AppBindingsTableItem,
        AppEstablishmentBindOptionModal,
    },

    data() {
        return {
            headers: [
                { text: "Nome", value: "nome", width: 220 },

                // Advertiser
                {
                    text: "Criar Campanha",
                    value: "ordem",
                    sortable: false,
                    align: "center",
                },
                {
                    text: "Ver Lead",
                    value: "nome",
                    sortable: false,
                    align: "center",
                },
                //{text: 'Aprovar Campanha', value: 'dataInicio', sortable: false, align: 'center'},

                // Establishment
                {
                    text: "Criar Campanha",
                    value: "ordem",
                    sortable: false,
                    align: "center",
                },
                {
                    text: "Ver Resultados",
                    value: "nome",
                    sortable: false,
                    align: "center",
                },
                //{text: 'Aprovar Campanha', value: 'dataInicio', sortable: false, align: 'center'},

                {
                    text: "Porcentagem Veiculação",
                    value: "porcentagemVeiculacao",
                    sortable: false,
                    align: "center",
                },

                // Remove bind
                {
                    text: "",
                    value: null,
                    sortable: false,
                    align: "center",
                    width: 60,
                },
            ],

            loading: false,
        };
    },

    mixins: [provider],

    computed: {
        items() {
            return this.$store.state.advertisers.boundEstablishments || [];
        },
    },

    props: {
        dataId: {
            type: Number,
            required: true,
        },
    },

    methods: {
        async load() {
            this.loading = true;
            await this.$loader.advertisers.boundEstablishments(this.dataId);
            this.loading = false;
        },
        loadEventHandler() {
            EventBus.$emit("LOAD_ADVERTISERS");
            this.load();
        },
    },

    mounted() {
        if (this.items.length === 0) this.load();

        EventBus.$on("ESTABLISHMENT_BOUND", this.loadEventHandler);
        EventBus.$on("ESTABLISHMENT_UNBOUND", this.loadEventHandler);
        EventBus.$on("ESTABLISHMENT_BOUND_LOAD", this.loadEventHandler);
    },

    beforeDestroy() {
        EventBus.$off("ESTABLISHMENT_BOUND", this.loadEventHandler);
        EventBus.$off("ESTABLISHMENT_UNBOUND", this.loadEventHandler);
        EventBus.$off("ESTABLISHMENT_BOUND_LOAD", this.loadEventHandler);
    },

    destroyed() {
        this.$store.commit("ADVERTISERS_CLEAR_BOUND_ESTABLISHMENTS");
    },
};
</script>

<style scoped>
.heading-grid {
    display: grid;
    grid-template-columns: 220px 1fr 1fr 80px;
}
</style>
